// Module
var code = "<div class=\"br-caption-2\" ng-class=\"$ctrl.status\"> {{$ctrl.status | translate}} </div> ";
// Exports
export default code;